export default {
  init() {
    // JavaScript to be fired on the partners page
  },
};

const careerSelect = $('.b-careers-list-hero__filter select');

careerSelect.select2({
  dropdownParent: $('.b-careers-list-filter'),
  minimumResultsForSearch: Infinity,
});



// WEBPACK FOOTER //
// ./scripts/routes/careers-list-filter.js